import cloneDeep from 'lodash.clonedeep';

import { MergeAssets } from '.';
import { GameDocument } from '../../../types/game-document';

export const AddNewOnDemandTaskCategoryAsync = async (
  gameDocument: GameDocument,
  newCategory: string
) => {
  const categories =
    cloneDeep(gameDocument.assets.onDemandTaskCategories) ?? [];
  const categoryExist = categories.find((c) => c === newCategory);

  if (!categoryExist) {
    categories.push(newCategory);
  }

  return MergeAssets(gameDocument, categories as any, 'onDemandTaskCategories');
};
